import { DataSource, Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutApiUserLookup extends Layout {
    sourceUsers: DataSource;
    tblUser: Table;
}
